import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosResponseHeaders,
} from 'axios';
import axios from 'axios';

import {
  ApiError,
  BASE_ERROR_CODE,
  BASE_ERROR_CODE_NAME_MAPPER,
} from './error';
import type { BaseApiResponse } from './type';

export const responseHandler = (res: AxiosResponse) => {
  return res;
};

const isBaseApiResponse = (value: any): value is BaseApiResponse<any> =>
  typeof value === 'object' && Object.hasOwn(value, 'resultCode');

export const responseErrorHandler = (
  error: AxiosError<BaseApiResponse<any>>,
) => {
  if (!error.response) {
    /* v8 ignore start */
    const errorJson = (error?.toJSON?.() as any) ?? {
      config: {},
      message: error.message,
      status: 500,
    };
    /* v8 ignore end */

    error.response = {
      config: errorJson.config,
      status: errorJson.status,
      statusText: errorJson.message,
      data: {} as any,
      headers: {} as AxiosResponseHeaders,
    };
  }

  if (error.response.status === +BASE_ERROR_CODE[401]) {
    error.response.data = {
      resultCode: error.response.data.resultCode ?? BASE_ERROR_CODE[3401],
      resultMsg: (error.response.data as any).message,
      resultData: error.response.data,
      trID: 'NONE',
    };
  }

  if (!isBaseApiResponse(error.response.data)) {
    const code = BASE_ERROR_CODE[9999];

    error.response.data = {
      resultCode: code,
      resultMsg: error.response.statusText || BASE_ERROR_CODE_NAME_MAPPER[code],
      resultData: error.response.data,
      trID: 'NONE',
    };
  }

  /* v8 ignore start */
  const resultCode = (error.response.data.resultCode ??
    BASE_ERROR_CODE[9999]) as keyof typeof BASE_ERROR_CODE_NAME_MAPPER;
  const errorClassName = BASE_ERROR_CODE_NAME_MAPPER[resultCode];
  const { data, headers, status, statusText } = error.response ?? {};
  /* v8 ignore end */

  throw new ApiError({
    data: data as any,
    headers: headers as AxiosResponseHeaders,
    message: data.resultMsg ?? error.message,
    name: `[${resultCode}] ${errorClassName}`,
    status,
    statusText,
    config: error.config,
  });
};

export const requestHandler = <T extends AxiosRequestConfig>(config: T) => {
  /* v8 ignore start */
  /* v8 ignore end */

  return config;
};

const createBaseAxiosInstance = () => {
  const instance = axios.create({
    timeout: 1000 * 20,
  });

  return instance;
};

export default createBaseAxiosInstance;
